import React, { useEffect, useState } from 'react'
// @ts-ignore no types
import { useApplicationContext } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import SectionPanel from 'common/components/sectionPanel'
import {
  fetchPropertyHistory,
  PropertyHistoryChange,
} from 'common/providers/propertyHistory'
import HistoryItem from './historyItem'

const PropertyHistory = () => {
  const { featureFlags, user } = useApplicationContext()
  const { activeListings } = useListingContext()
  const [changes, setChanges] = useState<PropertyHistoryChange[]>([])

  const unifiedPdpEnabled = featureFlags?.['fe.resi.enable-unified-pdp']
  // Property History requires BOTH the unified PDP flag and its own flag, so
  // it can be rolled out (or killed) independently of the unified PDP.
  const propertyHistoryEnabled =
    unifiedPdpEnabled && featureFlags?.['fe.resi.pdp.enable-property-history']
  const isLoggedIn = !!user?.logged_in

  const listingIds = (activeListings || []).map(l => l.listing_id)
  const listingIdsKey = listingIds.join(',')

  useEffect(() => {
    let active = true
    // field_change_timeline requires an authenticated session.
    if (!propertyHistoryEnabled || !isLoggedIn || !listingIds.length) {
      setChanges([])
      return undefined
    }
    fetchPropertyHistory(listingIds).then(result => {
      if (active) setChanges(result)
    })
    return () => {
      active = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listingIdsKey, propertyHistoryEnabled, isLoggedIn])

  // Do not render the section when there is nothing to show.
  if (!propertyHistoryEnabled || !changes.length) return null

  return (
    <SectionPanel elmId='property_history' title='Property History'>
      <div data-elm-id='property_history_list'>
        {changes.map((change, i) => (
          <HistoryItem
            key={`${change.field}_${change.changed_at}_${i}`}
            change={change}
          />
        ))}
      </div>
    </SectionPanel>
  )
}

export default PropertyHistory
